import React, { useState } from "react";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import { connect } from "react-redux";
import { missedSchoolReducer, mapDispatchToProps } from "./MissedSchool.store";
import AddMissedSchool from "../../library/AddMissedSchool/AddMissedSchool";
import CustomModal from "../../ui-library/CustomModal/CustomModal";
import ButtonDropdown from "../../ui-library/ButtonDropdown/ButtonDropdown";
import { useTranslation } from "react-i18next";
import { DEFAULT_MOMENT_LOCALE, isRtl } from "../../../i18n/helpers";
import { sendNotification } from "../../ToastManager/ToastManager";
import { ToastType } from "../../ToastManager/constants";
import { DateFormat } from "../../../modules/constants";

export const SmartMissedSchool = (props) => {
  const {
    addOrUpdateMissedSchool,
    removeMissedSchool,
    missedSchool,
    dailyItemKey,
    refreshData,
    date,
    didntFeelWell,
    studyVisitOrMedicalApt,
  } = props;

  const [showMissedSchoolModal, setShowMissedSchoolModal] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const { t } = useTranslation();

  const missedSchoolOptions = {
    ADD: {
      id: "add",
      text: t("appText.add"),
      type: "add",
      isDisabled: missedSchool,
      isVisible: true,
      onClick: () => openAddMissedSchool(),
    },
    EDIT: {
      id: "edit",
      text: t("appText.edit"),
      type: "edit",
      isDisabled: !missedSchool,
      isVisible: true,
      onClick: () => openAddMissedSchool(),
    },
    REMOVE: {
      id: "remove",
      text: t("appText.remove"),
      type: "remove",
      isDisabled: !missedSchool,
      isVisible: true,
      onClick: () => onRemoveMissedSchool(),
    },
  };

  const closeAddMissedSchool = () => {
    setShowMissedSchoolModal(false);
  };

  const openAddMissedSchool = () => {
    setShowMissedSchoolModal(true);
  };

  const onSubmitMissedSchool = (formData) => {
    setSubmitting(true);

    addOrUpdateMissedSchool(formData, missedSchool)
      .then((message) => {
        sendNotification(message, ToastType.SUCCESS);
        closeAddMissedSchool();
        refreshData();
      })
      .catch((error) => {
        sendNotification(error, ToastType.ERROR);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const onRemoveMissedSchool = () => {
    removeMissedSchool({
      date: date
        .locale(DEFAULT_MOMENT_LOCALE)
        .format(DateFormat.EXTENDED_DATETIME),
      missedSchool: false,
      didntFeelWell: false,
      studyVisitOrMedicalApt: false,
      reasonForChange: "",
    })
      .then((message) => {
        sendNotification(message, ToastType.SUCCESS);
        closeAddMissedSchool();
        refreshData();
      })
      .catch((error) => {
        sendNotification(error, ToastType.ERROR);
      });
  };

  return (
    <>
      <CustomModal
        show={showMissedSchoolModal}
        title={t("appText.dietDiary.missedSchool")}
        onClose={closeAddMissedSchool}
      >
        <AddMissedSchool
          onClose={closeAddMissedSchool}
          onSubmit={onSubmitMissedSchool}
          submitting={submitting}
          date={date}
          didntFeelWell={didntFeelWell}
          studyVisitOrMedicalApt={studyVisitOrMedicalApt}
        />
      </CustomModal>
      <ButtonDropdown
        dataTestId={`missed-school-${dailyItemKey}`}
        size="sm"
        title={t("appText.dietDiary.missedSchool")}
        checked={missedSchool}
        options={Object.values(missedSchoolOptions)}
        align={isRtl() ? "end" : "start"}
      />
    </>
  );
};

export default dynamic(
  "missedSchoolReducer",
  subspaced({
    mapExtraState: (state, rootState) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(missedSchoolReducer)
)(connect(null, mapDispatchToProps)(SmartMissedSchool));
